export default function errors() {
    return <p>Something went wrong..!</p>
}
export const AddSuccess = () => {
    return <p>Added successfully</p>
}

export const UpateSuccess = () => {
    return <p>Update successfully</p>
}
export const ActiveStatus = () => {
    return <p>Activated successfully </p>
}
export const DeActiveStatus = () => {
    return <p> De-activated successfully</p>
}
// clinic Error message object
export const clinicErrorMessageObj = {
    clinic_name: "Clinic name is required",
    first_name: "First name is required",
    last_name: "Last name is required",
    // contact: "contact number is required",
    designation: "Designation is required",
    // address: "Address is required",
    // postal_code: "ZipCode is required",
    // city: "City is required",
    // country: "Country is required",
    // state: "State is required",
    // npi_no: "NpiNo is required",
    // taxonomy: "Taxonomy is required",
};

export const clinicBranchErrorMessageObj = {
    branch_name: "Branch name is required",
    npi_no: "Npi no is required",
    taxonomy: "Taxonomy is required",
    fed_id: "FedId is required",
    office: "Office is required",
    fax: "Fax is required",
    // apartment: "apartment is required",
    address: "Address is required",
    zip_code: "Zip code is required",
    city: "City is required",
    country: "Country is required",
    state: "State is required",
};

export const patientDocumnetErrorMessageObj = {
    title: "Title name is required",
    description: "Description name is required",
};

export const contactError = "Contact number is required"

export const emailError = "Email is required"
export const validEmailId = "Please enter a valid email address";

export const profileImageError = "Profile photo is required"


//  
export const InsuranceErrorOnchange = {
    subscriber_first_name: " First name is required",
    subscriber_last_name: " Last name is required",
    subscriber_gender: "Please select gender",
    subscriber_id: "Subscriber id is required",
    group_number: "Group  is required",
    date_of_birth: "Date of birth is required",
    relationship: "Please selcet relation ",
    subscriber_address: " Address is required",
    subscriber_country: "Country is required",
    subscriber_state: "State is required",
    subscriber_city: "City is required",
    subscriber_zip_code: "Zip code is required",

    insurance_name: "Insurance name is required",
    mobile_no: " Mobile number  is required",
    insurance_type: "Please select insurance type",
    insurance_plan_type: "Please select insurance plan type",
    issue_date: "Please choose a date",
    insurance_address: "Address is required",
    insurance_country: "Country is required",
    insurance_state: "State is required",
    insurance_city: "City is required",
    insurance_zip_code: "Zip code is required",
    payer_id: "Payer id is required",
    copay: "Copay id is required",
    note: "Note id is required",
    insurance_company_id: "Please select insurance company"
};

export const billingTeamErrorMessageObj = {
    name: "Please enter Name",
    selectedClinic: "Please select clinic"
}

export const billingTeamMemberErrorMessageObj = {
    firstName: "FirstName is required",
    lastName: "Last name is required",
    email: "Email is required",
    role: "Role is required"
    // assignClinic: "Please select clinic"
}
export const apppointment_type_error = {
    appointmentType: "Please enter appointment type",
    duration: "Please select  duration",
    color: "Pleae select color",
    group: false,
    numberOfPatients: "Please enter number of patients"
}
// setting error message
export const insuranceS_Error = {
    city: "City is required",
    zipCode: "Zip code is required",
    address: "Address is required",
    insuranceName: "Insurance name is required",
    phoneNumber: "Phone number  is required",
    country: "Country is required",
    payerId: "Payer id is required",
    // Notes: "Note id is required",
    payer_id:"Payer id is required",
    state: "State is required",
    cp_id: "CP id is required"
}
export const cpt_Error = {
    price: "Price is required",
    cptCode: "Cpt  code is required",
    description: "Description is required",

}
export const ICD_Error = {
    ictCode: "Code is required",
    codeCategory: " Category code  is required",
    description: "Description is required",

}
export const Modifier_Error = {
    modifierCode: "Code is required",
    description: "Description is required",
}

export const checkoutFromReeorMessage = {

    // title: "Title is required",
    // firstName: "FirstName is required",
    // lastName: "LastName is required",
    // gender: "Gender is required",
    // dob: "Date of birth is required",
    // preferredMobile: "PreferredMobile is required",
    // alternateMobile: "AlternateMobile is required",
    // ssn: "SSN is required",
    // appartment: "Appartment is required",
    // address: "Address is required",
    // zip: "Zip is required",
    // city: "City is required",
    // state: "State is required",
    // country: "Country is required",
    // date: "Date is required",
    // time: "Time is required",
    // provider: "Provider is required",
    // appointmentType: "AppointmentType is required",
    // location: "Location is required",
    duration: "Duration is required",
    placeOfService: "Place of service is required",
    // remarks: "Remarks is required",
    // notes: "Notes is required",

}

export const other_claim_details_error = {
    relinquished_care_date: "Please select relinquished care date",
    property_casuality_claim_no: "Please enter property casuality claim no",
    hearing_vision_date: "Please select hearing vision date",
    first_visit_date: "Please select first visit date",
    acute_manifestation_date: "Please select acute manifestation date",
    last_seen_date: "Please select last seen date",
    assumed_care_date: "Please select assumed care date",
    last_x_ray_date: "Please select relinquished care date",
    initial_treatment_date: "Please select initial treatment date",
    additional_cliam_info: "Please enter additional cliam info",
    ct_project_code: "Please enter ct project code",
    other_constitutional: "Please enter other constitutional",
    lab_charges: "Please enter lab charges",
    mammography_certification_no: "Please enter mammography certification no",
    investigational_device_exemption_no: "Please enter enterinvestigational device exemption no",
    delay_reason_code: "Please enter delay reason code",
    original_ref_no: "Please enter original ref no",
    remarks: "Please enter remarks"

}